// Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import React from "react";
import ReactDOM from "react-dom/client";
import { AuthProvider } from "@asgardeo/auth-react";
import { AsgardeoConfig } from "./data/configs/spl-config";
import 'react-notifications-component/dist/theme.css'
import { ThemedApp } from "./components/ThemedApp";
import ErrorBoundary from "./ErrorBoundary";
import { ErrorPage } from "./pages/ErrorPage";

const App = () => (
  <AuthProvider config={AsgardeoConfig}>
    <ThemedApp />
  </AuthProvider>
);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <ErrorBoundary fallback={<ErrorPage />}>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
